import React from 'react';
import { useTranslation } from 'react-i18next';
import './FontFamilyInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { OverlayFontEnum } from '../../../types/enums/OverlayFontEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

export const FontFamilyInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in OverlayFontEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key}`,
        value: `${OverlayFontEnum[key as keyof typeof OverlayFontEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayFont: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          overlayFont: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="font-family-input">
      <div className="input-title">
        {t('producer.inputs.font-family.title')}
        <Help
          title="Font Family"
          text="Font Family changes the typeface used for captions in Open Captions mode.<br/><br/>- Select a font that is easy to read and suits your video style.<br/>- This setting only affects Open Captions, as Closed Captions use system defaults or player-specific styling.<br/><br/>Choosing the right font can improve readability and viewer experience."
        />
      </div>
      <Dropdown
        value={project.encoder.overlayFont.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.font-family.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.font-family.footer')}</div>
    </div>
  );
};

export default React.memo(FontFamilyInput);
